import React from "react";
import { copyText } from "../lib/clipboard";
import { Button } from "../design";

export function CopyPill({
  command,
  prompt = "$",
  host,
  onCopied,
}: {
  command: string;
  prompt?: string;
  host?: string;
  onCopied?: () => void;
}) {
  const [copied, setCopied] = React.useState(false);
  const tRef = React.useRef<number | null>(null);

  const onCopy = React.useCallback(async () => {
    await copyText(command);
    setCopied(true);
    if (tRef.current) window.clearTimeout(tRef.current);
    tRef.current = window.setTimeout(() => setCopied(false), 1200);
    onCopied?.();
  }, [command, onCopied]);

  const idx = host ? command.indexOf(host) : -1;
  return (
    <div className={`per-cmd${copied ? " copied" : ""}`}>
      <span className="per-cmd-prompt" aria-hidden>
        {prompt}
      </span>
      <code className="per-cmd-text" title={command} onClick={onCopy}>
        {idx < 0 || !host ? (
          command
        ) : (
          <>
            {command.slice(0, idx)}
            <span className="per-cmd-host">{host}</span>
            {command.slice(idx + host.length)}
          </>
        )}
      </code>
      <Button
        size="sm"
        variant="ghost"
        icon={copied ? "check" : "copy"}
        onClick={onCopy}
        aria-label="Copy install command"
      >
        {copied ? "Copied" : "Copy"}
      </Button>
    </div>
  );
}
